import IVscCommunityMapInfo, {IUnrealVector} from "../../../visualizers/IVscCommunityMapInfo";
import PropertyTable from "../../common/propertytable/PropertyTable";
import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";
import CameraAdminInfo, {vectorToString} from "../../admin/CameraAdmin";

import {IViewCamera, IViewItemConfig} from "../../../data/IViewpoint";



const AdminMapInfo: React.FC<{ mapInfo: IVscCommunityMapInfo, viewItems: IViewItemConfig[] }> = (props) => {

    const { mapInfo, viewItems } = props;
    const vscVisualizer = useVisualizerSession();
    const viewCamera = (cameraId:string) => {
        vscVisualizer.changeCamera(cameraId);
    }
    const enabledCameras = viewItems.filter(vi => vi.type === "camera") as IViewCamera[];
    return <section>
        <h3>Map Info</h3>
        <PropertyTable properties={{
            "Community": mapInfo.communityId,
            "Location": vectorToString(mapInfo.currentLocation),
            "LookAtDirection": vectorToString(mapInfo.currentLookAtDirection)
        }} />

        <h4>Cameras</h4>


        <CameraAdminInfo cameras={mapInfo.cameras} onViewCamera={viewCamera} enabledCameras={enabledCameras} />

    </section>
}
export default AdminMapInfo;